import api from '../dataAccessLayer/firebase'

let initialState = {
    userId: null,
    email: null,
    name: null,
    isFetching: false,
    isAuth: false
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_AUTH_STATUS':
            return {
                ...state,
                isAuth: action.status
            }
        case 'SET_USER_NAME':
            return {
                ...state,
                name: action.name
            }
        case 'SET_USER_ID':
            return {
                ...state,
                userId: action.userId
            }
        default:
            return state;
    }
}

export default authReducer;

export const setAuthStatus = status => ({type: 'SET_AUTH_STATUS', status})
export const setUserName = name => ({type: 'SET_USER_NAME', name})
export const setUserId = userId => ({type: 'SET_USER_ID', userId})





export const reg = (name, email, password) => dispatch => {
    console.log(email)
    console.log(password)
    api.register(name, email, password).then(u => {
        dispatch(setAuthStatus(true))
        dispatch(setUserName(api.getCurrentUsername()))
        dispatch(setUserId(api.getCurrentUserId()))
    })
}

export const login = (email, password) => dispatch => {
    api.login(email, password).then(u => {
        dispatch(setAuthStatus(true))
        dispatch(setUserId(api.getCurrentUserId()))
        dispatch(setUserName(api.getCurrentUsername()))

    })

}


export const logout = () => (dispatch) =>{
    api.logout().then(u =>  dispatch(setAuthStatus(false)))
}

